<template>
  <div class="mainDiv" v-loading="loading">
    <h2>{{ className }}</h2>
    <div class="tab">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-width="140px"
            size="mini"
            style="margin-left: 80px"
          >
            <el-row>
              <!-- <el-col :span="8">
                <el-form-item prop="courseName" label="课程名称：">
                  <el-input size="small" v-model="form.courseName"></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item prop="classCode" label="开课批次/班级编码：">
                  <el-input size="small" v-model="form.classCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="fullName" label="姓名：">
                  <el-input size="small" v-model="form.fullName"></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item prop="uname" label="用户名：">
                  <el-input size="small" v-model="form.uname"></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item prop="phone" label="手机号：">
                  <el-input size="small" v-model="form.phone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item label="课程考核结束时间：">
                  <el-date-picker
                    size="small"
                    v-model="assessTime"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    range-separator="至"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :unlink-panels="true"
                    style="width: 100%"
                    class="datetime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="finalScore" label="成绩：">
                  <div class="score_input">
                    <el-input
                      size="small"
                      v-model="form.finalScoreStartVal"
                      placeholder="分数"
                      class="minscore_input"
                      :class="{
                        border_focus: borderFocus,
                        border_hover: borderHover,
                      }"
                      @focus="focusBorder"
                      @blur="blurBorder"
                      @mouseover.native="overBorder"
                      @mouseleave.native="leaveBorder"
                    ></el-input>
                    <span class="score_input_range">至</span>
                    <el-input
                      size="small"
                      v-model="form.finalScoreEndVal"
                      placeholder="分数"
                      class="maxscore_input"
                      :class="{
                        border_focus: borderFocus,
                        border_hover: borderHover,
                      }"
                      @focus="focusBorder"
                      @blur="blurBorder"
                      @mouseover.native="overBorder"
                      @mouseleave.native="leaveBorder"
                    ></el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="scoreStatus" label="总评：">
                  <el-select
                    ref="applyTypeSelect"
                    v-model="form.scoreStatus"
                    placeholder="-不限-"
                    size="small"
                    @visible-change="visibleChange"
                  >
                    <el-option
                      v-for="item in overallList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="12">
                <el-form-item label="用户名：">
                  <el-col :span="5">
                    <el-input v-model="form.uname"></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="姓名：">
                  <el-col :span="5">
                    <el-input v-model="form.fullName"></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col>
                <el-form-item
                  label="练习完成情况："
                  prop="exerciseFinishStartVal"
                >
                  <el-col :span="5">
                    <el-input v-model="form.exerciseFinishStartVal"></el-input>
                  </el-col>
                  <el-col :span="1" style="width: 10px"> - </el-col>
                  <el-col :span="5">
                    <el-input
                      v-model="form.exerciseFinishEndVal"
                      ref="exerciseFinishEndVal"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :pull="5">
                <el-form-item
                  label="学习时长："
                  prop="attendanceFinishStartVal"
                >
                  <el-col :span="5">
                    <el-input
                      v-model="form.attendanceFinishStartVal"
                    ></el-input>
                  </el-col>
                  <el-col :span="1" style="width: 10px"> - </el-col>
                  <el-col :span="5">
                    <el-input
                      v-model="form.attendanceFinishEndVal"
                      ref="attendanceFinishEndVal"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col>
                <el-form-item label="测验完成情况：" prop="testFinishStartVal">
                  <el-col :span="5">
                    <el-input v-model="form.testFinishStartVal"></el-input>
                  </el-col>
                  <el-col :span="1" style="width: 10px"> - </el-col>
                  <el-col :span="5">
                    <el-input
                      v-model="form.testFinishEndVal"
                      ref="testFinishEndVal"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :pull="5">
                <el-form-item
                  label="综合测评："
                  prop="generalTestScoreStartVal"
                >
                  <el-col :span="5">
                    <el-input
                      v-model="form.generalTestScoreStartVal"
                    ></el-input>
                  </el-col>
                  <el-col :span="1" style="width: 10px"> - </el-col>
                  <el-col :span="5">
                    <el-input
                      v-model="form.generalTestScoreEndVal"
                      ref="generalTestScoreEndVal"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col>
                <el-form-item
                  label="作业完成情况："
                  prop="homeworkFinishStartVal"
                >
                  <el-col :span="5">
                    <el-input v-model="form.homeworkFinishStartVal"></el-input>
                  </el-col>
                  <el-col :span="1" style="width: 10px"> - </el-col>
                  <el-col :span="5">
                    <el-input
                      v-model="form.homeworkFinishEndVal"
                      ref="homeworkFinishEndVal"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :pull="5">
                <el-form-item
                  label="课堂出勤情况："
                  prop="classAttendanceFinishStartVal"
                >
                  <el-col :span="5">
                    <el-input
                      v-model="form.classAttendanceFinishStartVal"
                    ></el-input>
                  </el-col>
                  <el-col :span="1" style="width: 10px"> - </el-col>
                  <el-col :span="5">
                    <el-input
                      v-model="form.classAttendanceFinishEndVal"
                      ref="classAttendanceFinishEndVal"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col>
                <el-form-item
                  label="互动完成情况："
                  prop="interactFinishStartVal"
                >
                  <el-col :span="5">
                    <el-input v-model="form.interactFinishStartVal"></el-input>
                  </el-col>
                  <el-col :span="1" style="width: 10px"> - </el-col>
                  <el-col :span="5">
                    <el-input
                      v-model="form.interactFinishEndVal"
                      ref="interactFinishEndVal"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :pull="5">
                <el-form-item label="诚信表现：" prop="moralScoreStartVal">
                  <el-col :span="5">
                    <el-input v-model="form.moralScoreStartVal"></el-input>
                  </el-col>
                  <el-col :span="1" style="width: 10px"> - </el-col>
                  <el-col :span="5">
                    <el-input
                      v-model="form.moralScoreEndVal"
                      ref="moralScoreEndVal"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="成绩：" prop="finalScoreStartVal">
                  <el-col :span="5">
                    <el-input v-model="form.finalScoreStartVal"></el-input>
                  </el-col>
                  <el-col :span="1" style="width: 10px"> - </el-col>
                  <el-col :span="5">
                    <el-input
                      v-model="form.finalScoreEndVal"
                      ref="finalScoreEndVal"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row> -->
            <div class="btn" style="text-align: center">
              <el-row>
                <el-button type="primary" size="mini" @click="delAll"
                  >清空</el-button
                >
                <el-button type="primary" size="mini" @click="search"
                  >确定</el-button
                >
                <el-button size="mini" @click="toggle">关闭</el-button>
              </el-row>
            </div>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <div class="control">
        <el-button type="primary" @click="toggle">筛选</el-button>
        <el-button type="primary" @click="exportScore">导出筛选结果</el-button>
        <el-button type="primary" @click="importScoreDialogVisible = true"
          >导入考核分</el-button
        >
         <el-button type="primary" @click="showTipsDialog">督学</el-button>
        <!-- <el-button type="primary" @click="importAttendanceDialogVisible = true" 
          >导入课堂考勤</el-button
        > -->
        <el-button type="primary" @click="back">返回</el-button>
      </div>

      <el-dialog
        title="督学提醒："
        :visible.sync="tipsDialogVisible"
        width="30%"
        @close="closeTipsDialog"
        class="tips_dialog"
      >
        <el-form ref="tipsForm" :model="tipsForm" :rules="tipsFormRules">
          <el-form-item prop="tipsTextarea">
            <el-input
              type="textarea"
              :rows="6"
              v-model="tipsForm.tipsTextarea"
              @input="tipsTextareaChange"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="radio">
            <div v-for="(item, index) in tipsFormRadioList" :key="index">
              <el-radio
                v-model="tipsForm.radio"
                :label="item"
                @change="tipsFormRadioChange"
              ></el-radio>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="sendTips">发送</el-button>
          <el-button type="info" @click="tipsDialogVisible = false"
            >取消</el-button
          >
        </span>
      </el-dialog>

      <el-dialog
        title="导入考核分"
        :visible.sync="importScoreDialogVisible"
        width="30%"
        destroy-on-close
      >
        <span style="color: #d9001b"
          >注：考核分导入只针对主观分类考核进行导入，包含：诚信表现、作业完成情况、互动完成情况、三种考核分进行批量导入，其它考核分数由系统自动生成</span
        >
        <span
          slot="footer"
          class="dialog-footer"
          style="display: flex; justify-content: center"
        >
          <el-button
            type="primary"
            @click="downloadTemplate('score')"
            style="margin-right: 50px; width: 126px"
            >下载模板</el-button
          >
          <el-upload
            class="upload-demo"
            :action="
              url + '/zkfz/zkolCourseScore/importCourseCheckScoreWithAlbum'
            "
            :show-file-list="false"
            :on-success="uploadImportCourseCheckScore"
            :on-error="failUpload"
            style="position: relative"
          >
            <el-button type="primary">选择上传文件</el-button>
            <div
              slot="tip"
              class="el-upload__tip"
              style="position: absolute; bottom: -16px; left: 14px"
            >
              只能上传excel文件
            </div>
          </el-upload>
        </span>
      </el-dialog>

      <el-dialog
        title="导入课堂考勤"
        :visible.sync="importAttendanceDialogVisible"
        width="30%"
        destroy-on-close
      >
        <span style="color: #d9001b"
          >注：课堂考勤记录导入，包含：院校、学生名称、学号、课程名称、集中授课安排、课时、签到情况、签退情况、签到形式、有效学时时长</span
        >
        <span
          slot="footer"
          class="dialog-footer"
          style="display: flex; justify-content: center"
        >
          <el-button
            type="primary"
            @click="downloadTemplate('attendance')"
            style="margin-right: 50px; width: 126px"
            >下载模板</el-button
          >
          <el-upload
            class="upload-demo"
            :action="
              url + '/zkfz/zkolCourseScore/importClassAttendanceWithAlbum'
            "
            :show-file-list="false"
            :on-success="uploadClassAttendance"
            :on-error="failUpload"
            style="position: relative"
          >
            <el-button type="primary">选择上传文件</el-button>
            <div
              slot="tip"
              class="el-upload__tip"
              style="position: absolute; bottom: -16px; left: 14px"
            >
              只能上传excel文件
            </div>
          </el-upload>
        </span>
      </el-dialog>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
      size="small"
      @sort-change="sortChange"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      class="score_table"
    >
      <el-table-column width="50">
        <template slot="header">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
          />
        </template>
        <template slot-scope="scope">
          <el-checkbox
            v-model="scope.row.checked"
            @change="handleCheckOneChange"
          />
        </template>
      </el-table-column>
      <el-table-column width="50" label="序号" prop="rowNum"></el-table-column>
      <!-- <el-table-column label="开课批次/班级编码" prop="classCode">
        <template slot-scope="scope">
          <div></div>
          {{
            scope.row.classCode
              ? `${scope.row.batchName}/${scope.row.classCode}`
              : scope.row.batchName
          }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="课程名称" prop="courseName"></el-table-column> -->
      <!-- <el-table-column prop="courseName" label="课程名称" sortable="custom">
        <template slot-scope="scope">
          <div
            @click="
              showGeneralTest(scope.row.fullName, scope.row.courseScoreId)
            "
          >
            {{ scope.row.courseName }}
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="uname" label="用户名">
        <template slot-scope="scope">
          <div
            @click="
              showGeneralTest(scope.row.fullName, scope.row.courseScoreId)
            "
          >
            {{ scope.row.uname }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="fullName" label="姓名" sortable="custom">
        <template slot-scope="scope">
          <div
            @click="
              showGeneralTest(scope.row.fullName, scope.row.courseScoreId)
            "
          >
            {{ scope.row.fullName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="手机号(账号)" prop="phone"></el-table-column>
      <el-table-column prop="attendanceFinishInfo" label="学习时长">
        <template slot-scope="scope">
          <div
            @click="showStudyTime(scope.row.fullName, scope.row.courseScoreId)"
          >
            {{ scope.row.attendanceFinishInfo }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="exerciseFinishInfo" label="练习完成情况">
        <template slot-scope="scope">
          <div
            @click="
              showCompletionScore(
                scope.row.fullName,
                '练习',
                '1',
                scope.row.courseScoreId
              )
            "
          >
            {{ scope.row.exerciseFinishInfo }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="testFinishInfo" label="阶段作业">
        <template slot-scope="scope">
          <div
            @click="
              showCompletionScore(
                scope.row.fullName,
                '阶段作业',
                '2',
                scope.row.courseScoreId
              )
            "
          >
            {{ scope.row.testFinishInfo }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="generalTestScore" label="综合测评">
      </el-table-column>
      <el-table-column prop="moralScore" label="诚信表现"> </el-table-column>
      <el-table-column prop="classAttendanceFinishInfo" label="课堂出勤情况">
        <template slot-scope="scope">
          <div
            @click="
              showClassAttendance(
                scope.row.fullName,
                scope.row.courseScoreId,
                scope.row.uid,
                scope.row.courseId,
                scope.row.batchId
              )
            "
          >
            {{ scope.row.classAttendanceFinishInfo }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="homeworkScore" label="作业完成情况">
        <template slot-scope="scope">
          <div
            @click="
              showGeneralTest(scope.row.fullName, scope.row.courseScoreId)
            "
          >
            {{ scope.row.homeworkScore }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="interactScore" label="互动完成情况">
        <template slot-scope="scope">
          <div
            @click="
              showGeneralTest(scope.row.fullName, scope.row.courseScoreId)
            "
          >
            {{ scope.row.interactScore }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="finalScore"
        label="成绩"
        width="80"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column prop="scoreStatus" label="总评" width="100">
        <template slot-scope="scope">
          <div
            v-if="scope.row.orderOver === false"
            class="indicatorIncomplete"
            @click="
              showGeneralTest(
                scope.row.fullName,
                scope.row.courseScoreId,
                scope.row.uid
              )
            "
          >
            未到考核时间
          </div>
          <div
            v-if="scope.row.orderOver === true"
            :class="
              scope.row.scoreStatus === '未到考核时间'
                ? 'indicatorIncomplete'
                : ''
            "
            @click="
              showGeneralTest(
                scope.row.fullName,
                scope.row.courseScoreId,
                scope.row.uid
              )
            "
          >
            {{ scope.row.scoreStatus }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="assessEndTime" label="考核结束时间" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.assessEndTime[0] }}
          </div>
          <div>
            {{ scope.row.assessEndTime[1] }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
    <el-dialog
      :title="generalTestFullName + '综合考核情况'"
      :visible.sync="generalTestDialogVisible"
      width="670px"
      @close="closeGeneralTest"
    >
      <el-form
        ref="generalTestForm"
        :model="generalTestForm"
        label-width="120px"
      >
        <el-row type="flex">
          <el-col>
            <el-form-item label="成绩 : ">
              <el-input
                v-model="generalTestForm.finalScore"
                size="small"
                style="width: 180px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="总评 : ">
              <el-input
                v-model="generalTestForm.scoreStatus"
                size="small"
                :class="isIndicatorIncomplete ? 'indicatorIncomplete' : ''"
                style="width: 180px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col>
            <el-form-item label="学习时长 : ">
              <el-input
                v-model="generalTestForm.attendanceFinishInfo"
                size="small"
                style="width: 180px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="练习完成情况 : ">
              <el-input
                v-model="generalTestForm.exerciseFinishInfo"
                size="small"
                style="width: 180px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col>
            <el-form-item label="测验完成情况 : ">
              <el-input
                v-model="generalTestForm.testFinishInfo"
                size="small"
                style="width: 180px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="综合测评 : ">
              <el-input
                v-model="generalTestForm.generalTestScore"
                size="small"
                style="width: 180px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col>
            <el-form-item label="诚信表现 : ">
              <el-input
                v-model="generalTestForm.moralScore"
                size="small"
                placeholder="-请输入考试分数-"
                class="generalScoreTips"
                style="width: 180px"
                @blur="
                  saveCourseScore(
                    generalTestForm.courseScoreId,
                    'moralScore',
                    generalTestForm.moralScore
                  )
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="课堂出勤情况 : ">
              <el-input
                v-model="generalTestForm.classAttendanceFinishInfo"
                size="small"
                placeholder="请输入出勤情况"
                class="generalScoreTips"
                style="width: 180px"
                @focus="
                  focusClassAttendance(
                    generalTestForm.fullName,
                    generalTestForm.courseScoreId,
                    generalTestForm.uid,
                    generalTestForm.batchId
                  )
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col>
            <el-form-item label="作业完成情况 : ">
              <el-input
                v-model="generalTestForm.homeworkScore"
                size="small"
                placeholder="-请输入考试分数-"
                class="generalScoreTips"
                style="width: 180px"
                @blur="
                  saveCourseScore(
                    generalTestForm.courseScoreId,
                    'homeworkScore',
                    generalTestForm.homeworkScore
                  )
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="互动完成情况 : ">
              <el-input
                v-model="generalTestForm.interactScore"
                size="small"
                placeholder="-请输入考试分数-"
                class="generalScoreTips"
                style="width: 180px"
                @blur="
                  saveCourseScore(
                    generalTestForm.courseScoreId,
                    'interactScore',
                    generalTestForm.interactScore
                  )
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="generalTestDialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="attendanceFullName + '学习时长'"
      :visible.sync="studyTimeDialogVisible"
      width="670px"
    >
      <el-table
        :data="attendanceCompletionData"
        border
        size="mini"
        height="560"
      >
        <el-table-column
          property="rowNum"
          label="序号"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          property="videoTitle"
          label="课件资源"
          align="center"
          min-width="150"
        ></el-table-column>
        <el-table-column
          property="videoType"
          label="类型"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          property="finishStatus"
          label="完成情况"
          align="center"
          width="110"
        ></el-table-column>
        <el-table-column
          property="learnTime"
          label="学习时长"
          align="center"
          width="130"
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="studyTimeDialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="`${completionScoreFullName}${completionScoreTitle}完成情况`"
      :visible.sync="completionScoreDialogVisible"
      width="670px"
    >
      <el-table :data="thirdCompletionData" border size="mini" height="560">
        <el-table-column
          property="rowNum"
          label="序号"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          property="videoTitle"
          label="课件资源"
          align="center"
          min-width="150"
        ></el-table-column>
        <el-table-column
          property="videoType"
          label="类型"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          property="finishStatus"
          label="完成情况"
          align="center"
          width="110"
        ></el-table-column>
        <el-table-column
          property="topScore"
          label="最高成绩"
          align="center"
          width="130"
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="completionScoreDialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="classAttendanceFullName + '课堂出勤情况'"
      :visible.sync="classAttendanceDialogVisible"
      width="670px"
    >
      <el-table :data="classAttendanceData" border size="mini" height="560">
        <el-table-column
          property="rowNum"
          label="序号"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          property="videoTitle"
          label="集中授课安排"
          align="center"
          min-width="150"
        ></el-table-column>
        <el-table-column
          property="videoType"
          label="类型"
          align="center"
          width="60"
        ></el-table-column>
        <el-table-column
          property="signInfo"
          label="签到情况"
          align="center"
          width="80"
        >
          <template slot-scope="scope">
            <div
              style="cursor: pointer"
              @click="changeSignInfo(scope.row.signInfo, scope.$index)"
            >
              {{ scope.row.signInfo }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          property="signOutInfo"
          label="签退情况"
          align="center"
          width="80"
        >
          <template slot-scope="scope">
            <div
              style="cursor: pointer"
              @click="changeSignInfo(scope.row.signOutInfo, scope.$index)"
            >
              {{ scope.row.signOutInfo }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          property="learnTime"
          label="有效学习时长"
          align="center"
          width="130"
        ></el-table-column>
      </el-table>
      <div style="margin-top: 20px; color: #d9001b">
        温馨提示: 点击对应签到或签退单元格进行修改
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeClassAttendance"
          >保存</el-button
        >
        <el-button type="primary" @click="classAttendanceDialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api/learningOutcome/learningOutcome'
import * as api3 from '@/api/courseware/checkCourseware'
export default {
  data() {
    const patternZeroToHundredInteger = /^([0-9]{1,2}|100)$/ //0到100整数
    const validZeroToHundredInteger = (value, callback, endDom) => {
      const endVal = endDom.value || ''
      ;(patternZeroToHundredInteger.test(value) || value === '') &&
      (patternZeroToHundredInteger.test(endVal) || endVal === '')
        ? callback()
        : callback(new Error('请输入整数0~100'))
    }
    const validAttendanceFinish = (rule, value, callback) => {
      validZeroToHundredInteger(
        value,
        callback,
        this.$refs.attendanceFinishEndVal
      )
    }
    const validInteractFinish = (rule, value, callback) => {
      validZeroToHundredInteger(
        value,
        callback,
        this.$refs.interactFinishEndVal
      )
    }
    const validExerciseFinish = (rule, value, callback) => {
      validZeroToHundredInteger(
        value,
        callback,
        this.$refs.exerciseFinishEndVal
      )
    }
    const validHomeworkFinish = (rule, value, callback) => {
      validZeroToHundredInteger(
        value,
        callback,
        this.$refs.homeworkFinishEndVal
      )
    }
    const validTestFinishStartVal = (rule, value, callback) => {
      validZeroToHundredInteger(value, callback, this.$refs.testFinishEndVal)
    }
    const validGeneralTestScore = (rule, value, callback) => {
      validZeroToHundredInteger(
        value,
        callback,
        this.$refs.generalTestScoreEndVal
      )
    }
    const validClassAttendanceFinish = (rule, value, callback) => {
      validZeroToHundredInteger(
        value,
        callback,
        this.$refs.classAttendanceFinishEndVal
      )
    }
    const validMoralScore = (rule, value, callback) => {
      validZeroToHundredInteger(value, callback, this.$refs.moralScoreEndVal)
    }
    const validFinalScore = (rule, value, callback) => {
      validZeroToHundredInteger(value, callback, this.$refs.finalScoreEndVal)
    }
    return {
      loading: false,
      uid: '',
      courseId: this.$route.query.courseId || '',
      batchId: this.$route.query.batchId || '',
      orderAlbumId: this.$route.query.orderAlbumId || '', //班级ID
      classStudentUid: this.$route.query.uid || '', //班级学员id
      courseScoreId: '',
      className: '',
      activeName: 'first',
      activeNames: [],
      form: {
        uname: '',
        fullName: '',
        exerciseFinishStartVal: '',
        exerciseFinishEndVal: '',
        attendanceFinishStartVal: '',
        attendanceFinishEndVal: '',
        testFinishStartVal: '',
        testFinishEndVal: '',
        generalTestScoreStartVal: '',
        generalTestScoreEndVal: '',
        homeworkFinishStartVal: '',
        homeworkFinishEndVal: '',
        classAttendanceFinishStartVal: '',
        classAttendanceFinishEndVal: '',
        interactFinishStartVal: '',
        interactFinishEndVal: '',
        moralScoreStartVal: '',
        moralScoreEndVal: '',
        finalScoreStartVal: '',
        finalScoreEndVal: '',
        classCode:'',
        phone:''
      },
      rules: {
        attendanceFinishStartVal: [
          { validator: validAttendanceFinish, trriger: 'change' },
        ],
        interactFinishStartVal: [
          { validator: validInteractFinish, trriger: 'change' },
        ],
        exerciseFinishStartVal: [
          { validator: validExerciseFinish, trriger: 'change' },
        ],
        homeworkFinishStartVal: [
          { validator: validHomeworkFinish, trriger: 'change' },
        ],
        testFinishStartVal: [
          { validator: validTestFinishStartVal, trriger: 'change' },
        ],
        generalTestScoreStartVal: [
          { validator: validGeneralTestScore, trriger: 'change' },
        ],
        classAttendanceFinishStartVal: [
          { validator: validClassAttendanceFinish, trriger: 'change' },
        ],
        moralScoreStartVal: [{ validator: validMoralScore, trriger: 'change' }],
        finalScoreStartVal: [{ validator: validFinalScore, trriger: 'change' }],
      },
      checkAll: false,
      isIndeterminate: false,
      tableData: [],

      tipsDialogVisible: false,
      tipsForm: {
        tipsTextarea: '',
        radio: '',
      },
      tipsFormRadioList: ['备选1', '备选2'],
      tipsFormRules: {
        tipsTextarea: [
          { required: true, message: '请输入提醒语', trriger: 'blur' },
        ],
      },

      importScoreDialogVisible: false,
      importAttendanceDialogVisible: false,

      generalTestFullName: '',
      generalTestDialogVisible: false,
      generalTestForm: {},
      isIndicatorIncomplete: false,

      studyTimeDialogVisible: false,
      attendanceFullName: '',
      attendanceCompletionData: [],

      classAttendanceDialogVisible: false,
      classAttendanceFullName: '',
      classAttendanceBatchId: '',
      classAttendanceData: [],

      completionScoreDialogVisible: false,
      completionScoreFullName: '',
      thirdCompletionData: [],
      completionScoreTitle: '',
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      isSaveClassAttendance: true,
      courseScoreIdToHandleClick: '', //点击切换签到签退时用的id,
      sortObj: {
        orderByField: '',
        orderBy: '',
      },
      borderFocus: false,
      borderHover: false,
      overallList: [
        { label: '优秀', value: '1' },
        { label: '良好', value: '2' },
        { label: '合格', value: '3' },
        { label: '不及格', value: '4' },
        { label: '未到考核时间', value: '6' },
      ],
      assessTime: [],
      userType:null // 用户类型
    }
  },
  created() {
    if (this.orderAlbumId) {
      this.getElAlbumById()
    }
    this.getPageByWithAlbum({ page: '1', pageSize: '20' })
    this.getUserByUid();
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  methods: {
    //根据班级id获取班级名称和班主任名称
    async getElAlbumById() {
      const { code, data } = (
        await api.getElAlbumById({ albumId: this.orderAlbumId })
      ).data
      if (code === 100000) {
        if (data.name) {
          this.className = data.album_title + '（' + data.name + '）'
        } else {
          this.className = data.album_title + '（' + '）'
        }
      }
    },
    //获取学习结果列表（分页）
    getPageByWithAlbum() {
      this.loading = true
      let teacherId = this.getUId
      if (this.classStudentUid) teacherId = null
      // console.log('this.assessTime', this.assessTime)
      // console.log('backdt', this.$route.query.batchId)
      let assessEndTimeStartVal =
        (this.assessTime && this.assessTime.length && this.assessTime[0]) ||
        null
      let assessEndTimeEndVal =
        (this.assessTime && this.assessTime.length && this.assessTime[1]) ||
        null
      api
        .getPageByWithAlbum({
          ...this.form,
          ...this.pageObj,
          ...this.sortObj,
          assessEndTimeStartVal,
          assessEndTimeEndVal,
          // courseId: this.courseId,
          orderAlbumId: this.orderAlbumId,
          uid: this.classStudentUid,
          batchId:this.$route.query.batchId,
          teacherId,
        })
        .then((data) => {
          if (data.data.code === 100000) {
            const dataObj = data.data.data.page
            this.total = dataObj.total
            this.tableData = dataObj.list.map((item) => {
              return {
                ...item,
                checked: false,
                assessEndTime: (item.assessEndTime &&
                  item.assessEndTime.split(' ')) || ['', ''],
              }
            })
            this.loading = false
          } else {
            this.$message.error(data.data.msg)
            this.loading = false
          }
        })
        .catch((err) => {
          this.$message.error(err)
          this.loading = false
        })
    },
    //搜索的折叠面板
    toggle() {
      this.activeNames.length
        ? (this.activeNames = [])
        : (this.activeNames = ['1'])
    },
    //清空搜索内容
    delAll() {
      // this.form = this.$options.data().form
      this.form = {
        uname: '',
        fullName: '',
        exerciseFinishStartVal: '',
        exerciseFinishEndVal: '',
        attendanceFinishStartVal: '',
        attendanceFinishEndVal: '',
        testFinishStartVal: '',
        testFinishEndVal: '',
        generalTestScoreStartVal: '',
        generalTestScoreEndVal: '',
        homeworkFinishStartVal: '',
        homeworkFinishEndVal: '',
        classAttendanceFinishStartVal: '',
        classAttendanceFinishEndVal: '',
        interactFinishStartVal: '',
        interactFinishEndVal: '',
        moralScoreStartVal: '',
        moralScoreEndVal: '',
        finalScoreStartVal: '',
        finalScoreEndVal: '',
      }
      this.pageObj.page = 1
      this.assessTime = []
      this.getPageByWithAlbum()
    },
    //排序
    sortChange({ column, prop, order }) {
      this.sortObj.orderByField = prop
      if (order && order.indexOf('desc') !== -1) {
        this.sortObj.orderBy = 'desc'
      } else {
        this.sortObj.orderBy = 'asc'
      }
      this.getPageByWithAlbum()
    },
    focusBorder() {
      this.borderFocus = true
      this.borderHover = false
    },
    blurBorder() {
      this.borderFocus = false
    },
    overBorder() {
      if (!this.borderFocus) {
        this.borderHover = true
      }
    },
    leaveBorder() {
      this.borderHover = false
    },
    //搜索
    search() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$message.error('请输出正确的值或为空')
        }
        this.pageObj.page = 1
        this.getPageByWithAlbum()
        this.$message({
          type: 'success',
          message: '操作成功',
        })
      })
    },
    //导出excel
    exportScore() {
      const {
        uname,
        fullName,
        attendanceFinishStartVal,
        attendanceFinishEndVal,
        interactFinishStartVal,
        interactFinishEndVal,
        exerciseFinishStartVal,
        exerciseFinishEndVal,
        homeworkFinishStartVal,
        homeworkFinishEndVal,
        testFinishStartVal,
        testFinishEndVal,
        finalScoreStartVal,
        finalScoreEndVal,
        generalTestScoreStartVal,
        generalTestScoreEndVal,
        classAttendanceFinishStartVal,
        classAttendanceFinishEndVal,
        moralScoreStartVal,
        moralScoreEndVal,
      } = this.form
      const courseId = this.courseId || ''
      const uid = this.classStudentUid || ''
      window.open(
        `${this.url}/zkfz/zkolCourseScore/exportExcelByOrderAlbumId?orderAlbumId=${this.orderAlbumId}&courseId=${courseId}&uid=${uid}&uname=${uname}&fullName=${fullName}&attendanceFinishStartVal=${attendanceFinishStartVal}&attendanceFinishEndVal=${attendanceFinishEndVal}&interactFinishStartVal=${interactFinishStartVal}&interactFinishEndVal=${interactFinishEndVal}&exerciseFinishStartVal=${exerciseFinishStartVal}&exerciseFinishEndVal=${exerciseFinishEndVal}&homeworkFinishStartVal=${homeworkFinishStartVal}&homeworkFinishEndVal=${homeworkFinishEndVal}&testFinishStartVal=${testFinishStartVal}&testFinishEndVal=${testFinishEndVal}&finalScoreStartVal=${finalScoreStartVal}&finalScoreEndVal=${finalScoreEndVal}&generalTestScoreStartVal=${generalTestScoreStartVal}&generalTestScoreEndVal=${generalTestScoreEndVal}&classAttendanceFinishStartVal=${classAttendanceFinishStartVal}&classAttendanceFinishEndVal=${classAttendanceFinishEndVal}&moralScoreStartVal=${moralScoreStartVal}&moralScoreEndVal=${moralScoreEndVal}&batchId=${this.$route.query.batchId}`
      )
    },
    showTipsDialog() {
      const isChecked = this.tableData.some((item) => item.checked)
      if (isChecked) {
        this.tipsDialogVisible = true
      } else {
        this.$confirm('没有选择学生,将发送给所有学生', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning',
          center: true,
        })
          .then(() => {
            this.tipsDialogVisible = true
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    sendTips() {
      this.$refs.tipsForm.validate(async (valid) => {
        if (valid) {
          console.log(this.tableData)
          let uids = ''
          let courseIds = ''
          let batchIds = ''
          this.tableData.forEach((item) => {
            if (item.checked) {
              uids += item.uid + ','
              courseIds += item.courseId + ','
              batchIds += item.batchId + ','
            }
          })
          const { code, msg } = (
            await api.superintendent({
              ...this.form,
              ...this.pageObj,
              orderAlbumId: this.orderAlbumId,
              courseId: this.courseId,
              fromUid: this.getUId,
              content: this.tipsForm.tipsTextarea,
              uids,
              courseIds,
              batchIds,
            })
          ).data
          if (code === 100000) {
            this.tipsDialogVisible = false
            this.$message.success(msg)
          } else {
            this.$message.error(msg)
          }
        }
      })
    },
    closeTipsDialog() {
      this.$refs.tipsForm.resetFields()
    },
    tipsTextareaChange(val) {
      if (this.tipsFormRadioList.includes(val)) {
        this.tipsForm.radio = val
      } else {
        this.tipsForm.radio = ''
      }
    },
    tipsFormRadioChange(val) {
      this.tipsForm.tipsTextarea = val
    },
    //返回
    back() {
      // location.href = document.referrer
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host === 'fxl.sce.scut.edu.cn') {
        url += '/zk'
      }
      // window.location.href =
      //   url + '/index.php?app=course&mod=AdminAlbum&act=index&'
      // window.location.href =
      //   url + '/MyClassroomTution'
      this.$router.push('/MyClassroomTution')
        
    },
    //下载模板
    downloadTemplate(type) {
      console.log('type', type)
      let teacherId = this.getUId
      if (this.classStudentUid) teacherId = null
      let assessEndTimeStartVal =
        (this.assessTime && this.assessTime.length && this.assessTime[0]) ||
        null
      let assessEndTimeEndVal =
        (this.assessTime && this.assessTime.length && this.assessTime[1]) ||
        null

      let condition = `?assessEndTimeStartVal=${assessEndTimeStartVal}&assessEndTimeEndVal=${assessEndTimeEndVal}&batchId=${this.$route.query.batchId}&courseId=${this.courseId}&orderAlbumId=${this.orderAlbumId}&uid=${this.classStudentUid}&teacherId=${teacherId}&uname=${this.form.uname}&fullName=${this.form.fullName}&exerciseFinishStartVal=${this.form.exerciseFinishStartVal}&exerciseFinishEndVal=${this.form.exerciseFinishEndVal}&attendanceFinishStartVal=${this.form.attendanceFinishStartVal}&attendanceFinishEndVal=${this.form.attendanceFinishEndVal}&testFinishStartVal=${this.form.testFinishStartVal}&testFinishEndVal=${this.form.testFinishEndVal}&generalTestScoreStartVal=${this.form.generalTestScoreStartVal}&generalTestScoreEndVal=${this.form.generalTestScoreEndVal}&homeworkFinishStartVal=${this.form.homeworkFinishStartVal}&homeworkFinishEndVal=${this.form.homeworkFinishEndVal}&classAttendanceFinishStartVal=${this.form.classAttendanceFinishStartVal}&classAttendanceFinishEndVal=${this.form.classAttendanceFinishEndVal}&interactFinishStartVal=${this.form.interactFinishStartVal}&interactFinishEndVal=${this.form.interactFinishEndVal}&moralScoreStartVal=${this.form.moralScoreStartVal}&moralScoreEndVal=${this.form.moralScoreEndVal}
      &finalScoreStartVal=${this.form.finalScoreStartVal}
      &finalScoreEndVal=${this.form.finalScoreEndVal}`
      console.log('condition', condition)
      if (type === 'score') {
        window.open(
          this.url +
            '/zkfz/zkolCourseScore/exportCourseCheckScoreModelWithAlbum' +
            condition
        )
      } else if (type === 'attendance') {
        window.open(
          this.url +
            '/zkfz/zkolCourseScore/exportClassAttendanceModelWithAlbum' +
            condition
        )
      }
    },
    //导入考核分
    uploadImportCourseCheckScore(res, file, fileList) {
      let formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('batchId', this.batchId)
      formdata.append('createBy', localStorage.getItem('uid') )
      api.importCourseCheckScoreWithAlbum(formdata).then((data) => {
        const { code, msg } = data.data
        if (code === 100000) {
          this.$message.success(msg)
          this.getPageByWithAlbum()
          this.importScoreDialogVisible = false
        } else {
          this.$message.error(msg)
        }
      })
    },
    //导入课堂考勤
    uploadClassAttendance(res, file, fileList) {
      let formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('createBy', localStorage.getItem('uid') )
      api.importClassAttendanceWithAlbum(formdata).then((data) => {
        const { code, msg } = data.data
        if (code === 100000) {
          this.$message.success(msg)
          this.getPageByWithAlbum()
          this.importAttendanceDialogVisible = false
        } else {
          this.$message.error(msg)
        }
      })
    },
    failUpload(err) {
      this.$message.error(err)
    },

    handleCheckAllChange(val) {
      this.isIndeterminate = false
      this.tableData.forEach((item) => {
        item.checked = val
      })
    },
    handleCheckOneChange(val) {
      let totalCount = this.tableData.length
      let someStatusCount = 0
      this.tableData.forEach((item) => {
        if (item.checked === val) {
          someStatusCount++
        }
      })
      this.checkAll = totalCount === someStatusCount ? val : !val
      this.isIndeterminate = someStatusCount > 0 && someStatusCount < totalCount
    },

    //综合考核情况对话框
    showGeneralTest(name, courseScoreId, uid) {
      this.generalTestFullName = name
      this.uid = uid
      this.getOverallCourseScoreInfo(courseScoreId)
    },
    //获取综合考核情况
    getOverallCourseScoreInfo(courseScoreId) {
      this.courseScoreId = courseScoreId
      api.getOverallCourseScoreInfo({ courseScoreId }).then((data) => {
        const { code, data: list, msg } = data.data
        if (code === 100000) {
          const {
            scoreStatus,
            moralScore,
            classAttendanceFinishInfo,
            homeworkScore,
            interactScore,
            orderOver,
          } = list
          const checkScore = {
            moralScore,
            classAttendanceFinishInfo,
            homeworkScore,
            interactScore,
          }
          for (let key in checkScore) {
            if (checkScore[key].indexOf('-') > -1) list[key] = ''
          }
          if (orderOver === false) {
            list.scoreStatus = '未到考核时间'
            this.isIndicatorIncomplete = true
          } else {
            if (scoreStatus === '未到考核时间') {
              this.isIndicatorIncomplete = true
            }
          }
          this.generalTestForm = list
          this.generalTestDialogVisible = true
        } else {
          this.$message.error(msg)
        }
      })
    },
    //修改综合考勤成绩
    saveCourseScore(id, type, val) {
      this.$confirm('确定要更改吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning',
        center: true,
      })
        .then(() => {
          if (val.includes('分')) val = val.replace('分', '')
          api.saveCourseScore({ id, [type]: val }).then((data) => {
            const { code, msg } = data.data
            if (code === 100000) {
              this.getPageByWithAlbum()
              this.$message.success(msg)
            } else {
              this.$message.error(msg)
            }
          })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    //综合考核中打开课堂出勤
    focusClassAttendance(name, courseScoreId, uid, batchId) {
      this.showClassAttendance(name, courseScoreId, uid, null, batchId)
    },
    //修改课堂出勤情况
    changeClassAttendance() {
      let data = []
      this.classAttendanceData.forEach((item) => {
        let courseName = item.videoTitle
        let courseType = ''
        let id = item.id;
        let signInfo = item.signInfo
        let signOutInfo = item.signOutInfo
        if (item.videoType.indexOf('面授') > -1) {
          courseType = 1
        } else if (item.videoType.indexOf('直播') > -1) {
          courseType = 2
        }
        data.push({ courseName, courseType, signInfo, signOutInfo,id })
      })
      api
        .saveClassAttendance({
          classAttendanceBatchId: this.classAttendanceBatchId,
          courseId: this.currentCourseId,
          uid: this.uid,
          zkolClassAttendanceDetails: data,
        })
        .then(({ data }) => {
          if (data.code === 100000) {
            if (this.courseScoreId) {
              this.getOverallCourseScoreInfo(this.courseScoreId)
            }
            this.getPageByWithAlbum()
            // if (this.isSaveClassAttendance) {
            this.classAttendanceDialogVisible = false
            this.$message.success(data.msg)
            // } else {
            //   this.showClassAttendance(
            //     this.classAttendanceFullName,
            //     this.courseScoreIdToHandleClick,
            //     this.uid
            //   )
            // }
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    //分钟转时分秒
    minToClock(min) {
      let h = Math.floor(min / 60)
      h = h > 10 ? h : '0' + h
      let m = min % 60
      m = m > 10 ? m : '0' + m
      if (min.toString().includes('.5')) {
        m = Math.floor(m)
        m = m > 10 ? m : '0' + m
        return `${h}:${m}:30`
      } else {
        return `${h}:${m}:00`
      }
    },
    visibleChange(e) {
      if (!e) {
        this.$refs.applyTypeSelect.blur()
      }
    },
    //切换签到签退情况
    changeSignInfo(val, index) {
      // this.isSaveClassAttendance = false
      const period = this.classAttendanceData[index].period
      if (period === null) {
        return this.$message.error('未设置课时')
      }
      if (val === '已签到') {
        this.classAttendanceData[index].signInfo = '未签到'
      }
      if (val === '未签到') {
        this.classAttendanceData[index].signInfo = '已签到'
      }
      if (val === '未签退') {
        this.classAttendanceData[index].signOutInfo = '已签退'
      }
      if (val === '已签退') {
        this.classAttendanceData[index].signOutInfo = '未签退'
      }
      // this.changeClassAttendance()
      if (period === 0) {
        return this.$message('课时为0')
      }
      const timeOfOnePeriod = 45
      const halfPeriod = period / 2
      let time = timeOfOnePeriod * period
      time = this.minToClock(time)
      let halfTime = timeOfOnePeriod * halfPeriod
      halfTime = this.minToClock(halfTime)
      const signInfo = this.classAttendanceData[index].signInfo
      const signOutInfo = this.classAttendanceData[index].signOutInfo
      if (signInfo === '未签到' && signOutInfo === '未签退') {
        this.classAttendanceData[index].learnTime = '00:00:00'
      } else if (signInfo === '未签到' && signOutInfo === '已签退') {
        this.classAttendanceData[index].learnTime = halfTime
      } else if (signInfo === '已签到' && signOutInfo === '未签退') {
        this.classAttendanceData[index].learnTime = halfTime
      } else if (signInfo === '已签到' && signOutInfo === '已签退') {
        this.classAttendanceData[index].learnTime = time
      }
    },
    closeGeneralTest() {
      this.generalTestForm = {}
      this.courseScoreId = ''
    },
    //学习时长对话框
    showStudyTime(name, courseScoreId) {
      this.attendanceFullName = name
      api
        .getCourseScoreInfo({ courseScoreId, infoStatus: '0' })
        .then((data) => {
          const { code, data: list, msg } = data.data
          if (code === 100000) {
            this.attendanceCompletionData = list.result
            this.studyTimeDialogVisible = true
          } else {
            this.$message.error(msg)
          }
        })
    },
    //课堂出勤情况对话框
    showClassAttendance(name, courseScoreId, uid, courseId, batchId) {
      this.uid = uid
      this.classAttendanceFullName = name
      this.currentCourseId = courseId
      this.classAttendanceBatchId = batchId
      // this.courseScoreIdToHandleClick = courseScoreId
      api
        .getCourseScoreInfo({ courseScoreId, infoStatus: '3' })
        .then((data) => {
          const { code, data: list, msg } = data.data
          if (code === 100000) {
            this.classAttendanceData = list.result
            this.classAttendanceDialogVisible = true
            this.isSaveClassAttendance = true
          } else {
            this.$message.error(msg)
          }
        })
    },
    //完成情况分数对话框
    showCompletionScore(name, title, infoStatus, courseScoreId) {
      this.completionScoreFullName = name
      this.completionScoreTitle = title
      api.getCourseScoreInfo({ courseScoreId, infoStatus }).then((data) => {
        const { code, data: list, msg } = data.data
        if (code === 100000) {
          this.thirdCompletionData = list.result
          this.completionScoreDialogVisible = true
        } else {
          this.$message.error(msg)
        }
      })
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getPageByWithAlbum()
    },
    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getPageByWithAlbum()
    },
    // 获取用户信息
    getUserByUid() {
      api3.getUserByUid(this.getUId).then(({ data }) => {
        if (data.code === 100000) {
          this.userType = data.data.type
          console.log('this.userType',this.userType)
        }
      })
    },
  },
}
</script>
<style lang='scss' scoped>
.tab {
  text-align: left;
  font-size: 0;
  .control {
    display: flex;
    align-items: center;
    height: 60px;
    padding-left: 20px;
    background: #f6f6f6;
  }
  /deep/ .tips_dialog {
    .el-dialog__title {
      font-weight: 700;
    }
  }
}
/deep/.score_status_time_dialog {
  .el-dialog__body,
  .el-dialog__footer {
    display: flex;
    justify-content: center;
  }
}
/deep/ .generalScoreTips .el-input__inner::placeholder {
  color: #d9001b;
}
/deep/.indicatorIncomplete {
  color: #d9001b;
  .el-input__inner {
    color: #d9001b;
  }
}
/deep/.score_table .el-table__body-wrapper .el-table__body .el-table__row {
  td:nth-child(3) .cell {
    cursor: pointer;
  }
  td:nth-child(4) .cell {
    cursor: pointer;
  }
  td:nth-child(5) .cell {
    cursor: pointer;
  }
  td:nth-child(6) .cell {
    color: #00a7cc;
    cursor: pointer;
  }
  td:nth-child(7) .cell {
    color: #00a7cc;
    cursor: pointer;
  }
  td:nth-child(8) .cell {
    color: #00a7cc;
    cursor: pointer;
  }
  td:nth-child(9) .cell {
    color: #00a7cc;
  }
  td:nth-child(10) .cell {
    color: #00a7cc;
  }
  td:nth-child(11) .cell {
    color: #00a7cc;
    cursor: pointer;
  }
  td:nth-child(12) .cell {
    color: #00a7cc;
    cursor: pointer;
  }
  td:nth-child(13) .cell {
    color: #00a7cc;
    cursor: pointer;
  }
  td:nth-child(15) .cell {
    cursor: pointer;
  }
}
/deep/.el-collapse-item__header {
  display: none;
}
/deep/.el-collapse-item__wrap {
  border: none;
}
/deep/.el-collapse {
  border: none;
  padding-bottom: 20px;
}

/deep/ .el-range-separator {
  width: 15% !important;
}
/deep/.minscore_input,
.maxscore_input {
  width: 50%;
}
.score_input {
  position: relative;
  .score_input_range {
    position: absolute;
    left: 47%;
    top: 0;
    line-height: 30px;
    z-index: 999;
  }
}

/deep/.maxscore_input {
  .el-input__inner {
    border-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .el-input__inner::placeholder {
    text-align: center;
  }
}

/deep/.minscore_input {
  .el-input__inner {
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
/deep/.border_focus {
  .el-input__inner {
    border-color: #409eff;
    outline: 0;
  }
}
/deep/.border_hover {
  .el-input__inner {
    border-color: #c0c4cc;
  }
}
</style>